import Navbar from '../../components/navbar/navbar.jsx'

import shopeeLogo from '../../assets/shopee.svg'

import { useCallback, useEffect, useState } from 'react'
import { BagFill, CheckCircleFill } from 'react-bootstrap-icons'
import { useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { CustomButton } from '../../components/CustomButton/index.jsx'
import { CustomSpinner } from '../../components/CustomSpinner/index.jsx'
import apinode from '../../services/apinode.js'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage.js'
import { Container, Content } from './styles.js'

export function ShopeeAuthentication() {
  const [isLoadingRequest, setIsLoadingRequest] = useState(false)
  const [hasBeenSucceed, setHasBeenSucceed] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const [searchParams] = useSearchParams()

  async function handleAuth() {
    try {
      setIsLoadingRequest(true)

      const response = await apinode.get(`/shopee-auth`)

      window.open(response.data, '_blank').focus()
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível obter a url para autenticação!',
      )
    } finally {
      setIsLoadingRequest(false)
    }
  }

  const getParams = useCallback(async () => {
    const code = searchParams.get('code')
    const shop_id = searchParams.get('shop_id')

    if (code && shop_id) {
      try {
        setIsLoading(true)

        await apinode.post(`/shopee-auth/${localStorage.idconta}`, {
          shop_id,
          code,
        })

        toast.success('Autenticação realizada com sucesso!')
        setHasBeenSucceed(true)
      } catch (err) {
        sendErrorApiMessage(err, 'Não foi possível realizar a autenticação!')
      } finally {
        setIsLoading(false)
      }
    }
  }, [searchParams])

  useEffect(() => {
    if (!hasBeenSucceed) {
      getParams()
    }
  }, [getParams, hasBeenSucceed])

  return (
    <>
      <Navbar />

      <Container>
        <Content>
          {hasBeenSucceed ? (
            <>
              <CheckCircleFill
                color="#229954"
                size={35}
              />
              <h1>Autenticação bem-sucedida</h1>
            </>
          ) : isLoading ? (
            <CustomSpinner color="#ee4d2d" />
          ) : (
            <h1>Autenticação</h1>
          )}

          <span className="divider"></span>
          <img
            src={shopeeLogo}
            alt="Shopee Logo"
          />
        </Content>

        {!hasBeenSucceed && (
          <CustomButton
            color="#ee4d2d"
            title="Autenticar"
            onClick={handleAuth}
            isLoading={isLoadingRequest}
            isLoadingText="Redirecionando..."
          >
            <BagFill />
          </CustomButton>
        )}
      </Container>
    </>
  )
}
